<template>
  <!--  <a-spin :spinning="isLoading">-->
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cell-db-click="updateRow"
        @toolbar-addData="addRow"
        @toolbar-delData="delRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="publish">发布并通知</vxe-button>
        <vxe-button @click="update(2)">结束</vxe-button>
        <!--        <vxe-button @click="send">通知员工</vxe-button>-->
        <vxe-button @click="prizeInfo">中奖信息</vxe-button>
        <vxe-button @click="statistics">统计分析</vxe-button>
      </template>
      <template v-slot:operate="{row}">
        <vxe-button size="mini" status="primary" @click="fissionPreview(row.fissionId)">
          预览
        </vxe-button>
      </template>
    </x-grid>

<!--    erCodePop-->
    <a-modal
        title="预览"
        centered
        :footer="null"
        :maskClosable="false"
        v-model="erCodePop"
        :width="400"

    >

        <img :src="api.temp.FILE_PATH + imgUrl" />



    </a-modal>

    <!--明细页表单简化通用写法-->
    <formModal title="裂变" :visible="editModalVisible">
      <detailForm :rowId="editRowId"
                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </detailForm>
    </formModal>
    <!--明细页表单简化通用写法-->
    <a-modal
        title="中奖信息"
        centered
        :footer="null"
        :maskClosable="false"
        v-model="prizeModalVisible"
        :width="1200"
    >
      <prizeForm :fissionId="fissionId" v-if="prizeModalVisible" ref="prizeForm"></prizeForm>
    </a-modal>
    <a-modal
        title="选择裂变员工"
        centered
        :maskClosable="false"
        v-model="publistModalVisible"
        @ok="publistSave"
        :width="800"
    >
      <div class="ant-row ant-form-item">
        <div class="ant-col ant-col-4 ant-form-item-label">
          <label class="ant-form-item-required">选择员工</label>
        </div>
        <div class="ant-col ant-col-18 ant-form-item-control-wrap++per">
          <userPickerWithNoParents ref="userPickerWithNoParents" v-if="publistModalVisible" :operateList="operateList"></userPickerWithNoParents>
        </div>
      </div>
      <div class="ant-row ant-form-item">
        <div class="ant-col ant-col-4 ant-form-item-label">
          <label class="ant-form-item">选择标签</label>
        </div>
        <div class="ant-col ant-col-18 ant-form-item-control-wrapper">
          <TagPicker v-model="tagIds"></TagPicker>
        </div>
      </div>
    </a-modal>

    <!--统计分析弹窗-->
    <a-modal
        title="统计分析"
        centered
        :footer="null"
        :maskClosable="false"
        v-model="statisticsModalVisible"
        :width="1200"
    >
      <fissionStatisticsList v-if="statisticsModalVisible" :fissionId="fissionId" ref="fissionStatisticsList"></fissionStatisticsList>
    </a-modal>
  </div>
  <!--  </a-spin>-->
</template>

<script>
import {
  GridMixin,
  api,
  fac,
} from "@/utils/common/XGridBase"

import detailForm from "./detail";
import prizeForm from "./prizeInfo";
import fissionStatisticsList from "../fissionStatistics/list";
import {dataApi} from "@/services/operate/marketingFission";
import userPickerWithNoParents from '@/components/picker/userPickerWithNoParents.vue';
import TagPicker from '@/components/picker/tagPicker.vue';

//列表接口
const url = api.operate.MARKETINGFISSION;

//主键
const rowId = 'fissionId';

//列
const columns = [
  // fac.makeColumnRadioDefault(),
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("fissionName", "活动名称", 160),
  fac.makeColumn("startTime", "活动开始时间", 160),
  fac.makeColumn("endTime", "活动结束时间", 160),
  fac.makeColumn("statusName", "活动状态", 120),
  fac.makeColumn("oldCustNum", "新客户数", 120),
  fac.makeColumn("newCustNum", "老客户数", 120),
  fac.makeColumn("createUserName", "创建人", 120),
  fac.makeColumn("createDate", "创建时间", 120),
  fac.makeColumn({
    title: "操作",
    field: 'operate',
    slots: {
      default: 'default'
    },
    align: 'center',
    width: 200,
    fixed:'right'
  }),
]

//筛选项
const formConfig = fac.makeFormConfig(columns, [
  {field: 'fissionName'},
  {
    field: "statusName",
    type: "select",
    options: [{label: '全部', value: ''}, {label: '发布中', value: '发布中'}, {label: '待发布', value: '待发布'}, {
      label: '已结束',
      value: '已结束'
    }]
  },
  {field: 'createUserName'},
])

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: true,
  delData: true,
  addData: true,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

async function loadBaseData() {

}

export default {
  mixins: [GridMixin],
  components: {
    detailForm, prizeForm, userPickerWithNoParents, TagPicker,fissionStatisticsList
  },
  data() {
    return {
      operateList:true,
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      prizeModalVisible: false,
      statisticsModalVisible:false,
      publistModalVisible: false,
      fissionId: 0,
      tagIds: '',
      erCodeUrl:'',
      erCodePop:false,
      flag:true,

      imgUrl:'',
    }
  },
  async mounted() {
  },
  methods: {
    loadBaseData,
    /**
     * ready 需要返回布尔
     */
    setOpenReady() {
      let row = this.getRows();
      if (row.length !== 1) {
        this.$message.error('请选择一条数据');
        return false;
      }
      if (row[0].isUse) {
        this.$message.error('该数据已启用');
        return false;
      }
      return true;
    },
    async setOpen() {
      let row = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      this.loading(true);
      await dataApi.updateIsUse(row[0][this.rowId]).then(() => {
        this.$message.success('启用成功');
        this.loading(false);
      }).catch(() => {
        this.loading(false);
      });
      this.refresh()
    },
    update(status) {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      const ids = rows.map(item => {
        return item.fissionId
      }).toString()
      dataApi.updateStatus(ids, status).then(res => {
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.refresh()
        }
      })
    },
    publish() {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length < 1) {
        this.$message.error('请选择裂变活动')
        return false
      }
      this.publistModalVisible = true
    },
    publistSave() {
      this.$message.success('尝试发布...请稍候')
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      const ids = rows.map(item => {
        return item.fissionId
      }).toString()
      const result = {
        tagIds: this.tagIds,
        fissionIds: ids,
        status: 1,
      }
      const params = this.$refs.userPickerWithNoParents.getSelectData()
      if (params.userIds.length === 0 && params.deptIds.length === 0) {
        this.$message.error('请选择员工')
        return false
      }
      if (params.type === 'customer') {
        result.userIds = params.userIds
      } else {
        result.deptIds = params.deptIds
      }
      dataApi.updateStatusFission(result).then(res => {
        if (res.code === 200) {
          this.$message.success('发布成功')
          this.publistModalVisible=false
          this.refresh()

        }
      })
    },
    send() {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length !== 1) {
        this.$message.error('请选择一条数据')
        return false
      }
      if (rows[0].fissionStatus !== 1) {
        this.$message.error('请选择已发布的活动')
        return false
      }
      dataApi.createMsgTask(rows[0].fissionId).then(res => {
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.refresh()
        }
      })
    },
    prizeInfo() {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length !== 1) {
        this.$message.error('请选择一条数据')
        return false
      }
      this.fissionId = rows[0].fissionId
      this.prizeModalVisible = true
    },
    statistics() {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length !== 1) {
        this.$message.error('请选择一条数据')
        return false
      }
      this.fissionId = rows[0].fissionId
      this.statisticsModalVisible = true;
      // this.$router.push('/operate/fissionStatistics?id='+this.fissionId)
    },
    fissionPreview(row){
      console.log('fission row',row)
      let that = this;
        dataApi.previewFission(row).then(res => {
          console.log(res)
          if (res.code === 200) {
            that.$nextTick(()=>{
              that.imgUrl = res.data.url;
            })
            setTimeout(()=>{
              that.erCodePop = true
            },500)
          }
        })
    }
  }
}
</script>

<style scoped>
</style>
